import React, { useState, useRef } from "react"

import Modal from "@/components/core/Modal/Modal"
import Button from "@/components/core/Button/Button"

import { sanitizeInnerHtml } from "@/utils/helper"
import {
  getDeleteButtonAnalytics,
  getEventInfo,
} from "@/components/AccountSettings/v1/AccountManagement/analytics"

import accountManagementStyle from "@/components/AccountSettings/v1/AccountManagement/index.module.scss"

const AccountManagement = ({
  i18n = {},
  onDeleteAccount = () => {},
  ...props
}) => {
  const [showModal, setShowModal] = useState(false)

  const openModal = () => {
    setShowModal(true)
  }
  const closeModal = () => {
    setShowModal(false)
  }
  const handleDelete = () => {
    closeModal()
    onDeleteAccount()
  }

  const modalWindow = useRef(null)

  return (
    <div className={`${accountManagementStyle?.accountManagementStyleWrapper}`}>
      <div className={`account-management`}>
        <Modal
          showModal={showModal}
          onModalClose={closeModal}
          closeButtonAnalytics={getEventInfo("close")}
        >
          <div
            className="account-settings__modal"
            aria-modal
            role="dialog"
            tabIndex="-1"
            ref={modalWindow}
            aria-labelledby="account-management__delete_modal--title"
            aria-describedby="account-management__delete_modal--desc"
          >
            <div
              id="account-management__delete_modal--title"
              className="account-settings__modal-title"
            >
              {i18n?.accountDeleteTitle}
            </div>
            <div
              id="account-management__delete_modal--desc"
              className="account-management__modal-desc"
            >
              {i18n?.accountDeleteMssg}
            </div>
            <div className="account-management__modal-cta">
              <Button
                className="gbh-data-layer"
                useDefaultClass={true}
                data-gbh-data-layer={getEventInfo("no save account")}
                type="ghost"
                role="button"
                label={i18n?.noSave}
                onClick={() => closeModal()}
              />
              <Button
                className="gbh-data-layer"
                useDefaultClass={true}
                data-gbh-data-layer={getEventInfo("yes delete account")}
                type="black"
                role="button"
                label={i18n?.yesDelete}
                onClick={() => handleDelete()}
              />
            </div>
          </div>
        </Modal>
        <div className="account-settings__section-header">
          <h3 className="account-settings__section-title">
            {i18n?.accountManagement}
          </h3>
        </div>
        <div className="account-management__content">
          <div className="account-management__desc">
            {sanitizeInnerHtml(i18n?.deleteMssg)}
          </div>
          <div className="account-management__cta">
            <Button
              type="ghost"
              role="button"
              size="small"
              flexible
              label={i18n?.deleteAccount}
              onClick={() => openModal()}
              className="gbh-data-layer"
              data-gbh-data-layer={getDeleteButtonAnalytics()}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AccountManagement
